import React, { useState } from "react";
import {
  FiPackage,
  FiSearch,
  FiCheckCircle,
  FiTruck,
  FiHome,
} from "react-icons/fi";
import toast from "react-hot-toast";
import "../styles/track-order.css";

const TrackOrder = () => {
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [tracking, setTracking] = useState(false);
  const [orderStatus, setOrderStatus] = useState(null);

  const handleTrack = (e) => {
    e.preventDefault();
    if (!orderNumber || !email) {
      toast.error("Please enter both order number and email");
      return;
    }
    setTracking(true);
    // Simulate API call
    setTimeout(() => {
      setOrderStatus({
        status: "shipped",
        orderNumber: orderNumber,
        date: "2024-03-15",
        items: 3,
        trackingNumber:
          "TRK" + Math.random().toString(36).substr(2, 8).toUpperCase(),
      });
      setTracking(false);
      toast.success("Order found!");
    }, 1500);
  };

  const statusSteps = [
    { key: "pending", label: "Order Placed", icon: FiPackage },
    { key: "processing", label: "Processing", icon: FiCheckCircle },
    { key: "shipped", label: "Shipped", icon: FiTruck },
    { key: "delivered", label: "Delivered", icon: FiHome },
  ];

  const currentStepIndex = orderStatus
    ? statusSteps.findIndex((s) => s.key === orderStatus.status)
    : -1;

  return (
    <div className="track-order-page">
      <div className="container">
        <section className="track-hero">
          <h1>Track Your Order</h1>
          <p>Enter your order number and email to check your order status</p>
        </section>

        <div className="track-form-container">
          <form onSubmit={handleTrack} className="track-form">
            <input
              type="text"
              placeholder="Order Number (e.g., #ORD-12345)"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={tracking}>
              <FiSearch /> {tracking ? "Tracking..." : "Track Order"}
            </button>
          </form>
        </div>

        {orderStatus && (
          <div className="track-result">
            <div className="order-info">
              <h3>Order #{orderStatus.orderNumber}</h3>
              <p>Placed on: {orderStatus.date}</p>
              <p>Items: {orderStatus.items}</p>
              <p>Tracking: {orderStatus.trackingNumber}</p>
            </div>

            <div className="tracking-steps">
              {statusSteps.map((step, index) => {
                const Icon = step.icon;
                const isCompleted = index <= currentStepIndex;
                const isCurrent = index === currentStepIndex;
                return (
                  <div
                    key={step.key}
                    className={`track-step ${isCompleted ? "completed" : ""} ${isCurrent ? "current" : ""}`}
                  >
                    <div className="step-icon">
                      <Icon />
                    </div>
                    <div className="step-label">{step.label}</div>
                    {index < statusSteps.length - 1 && (
                      <div className="step-line"></div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="order-actions">
              <a href="/shop" className="btn-shop">
                Continue Shopping
              </a>
              <a href="/contact" className="btn-support">
                Need Help?
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackOrder;
